import script from "./GeneralButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralButton.vue?vue&type=script&setup=true&lang=js"

import "./GeneralButton.vue?vue&type=style&index=0&id=345a8350&lang=css"

const __exports__ = script;

export default __exports__